import { setPageStateById } from '../PageContext';

export const setLoading = (setState: setPageStateById) => (loading: boolean, featureId: string) => {
  if (loading) {
    setState('SET_PAGE_FEATURE_LOADING_TRUE', (s) => {
      const featureIndex = s.loadingFeatures.findIndex((e) => e === featureId);
      if (featureIndex === -1) {
        s.loadingFeatures.push(featureId);
      }
      return {
        ...s,
        loading,
        // loadingFeatures: s.loadingFeatures,
      };
    });
  } else {
    setState('SET_PAGE_FEATURE_LOADING_FALSE', (s) => {
      const featureIndex = s.loadingFeatures.findIndex((e) => e === featureId);
      if (featureIndex !== -1) s.loadingFeatures.splice(featureIndex, 1);
      const newLoading = s.loadingFeatures.length !== 0;
      return {
        ...s,
        loading: newLoading,
        // loadingFeatures: s.loadingFeatures,
      };
    });
  }
};
